import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Card, Form, Button, Tabs, Tab, } from 'react-bootstrap';
import Select from 'react-select';
import { useFetch } from '@np/np_webcomponentlib'

import { API_BUSINESS } from '../../shared/consts/api'

import { EntityType, DataEntityType, columnsRate } from './BusinessTypes'
import { useParams } from 'react-router-dom';
import { BusinessForm } from './BusinessForm';


import { DataEntityType as RateEntityType } from '../Rate/RateTypes'
import ProductProviderList from '../ProductProvider/ProductProviderList';
import DashboardBusiessMain from '../DashboardBusiness/DashboardBusiessMain';
import UserBusinessList from '../UserBusiness/UserBusinessList';
import DRRateComissionList from '../DRRateComission/DRRateComissionList';

import RateDataList from '../RateData/RateDataList';



import Report from '../Report/Report'
import CopyToClipboard from 'react-copy-to-clipboard';
import { TypeBusinessEnum } from '../../shared/MasterData/MasterDataTypes';

import ProviderCodeGenerator from '../../components/CodeGenerator/ProviderCodeGenerator';
import CalculateDiffExchangeRate from '../OperationProviderSettle/CalculateDiffExchangeRate';
import SettleFiatMerchant from '../OperationProviderSettle/SettleFiatMerchant';
import CallbackResend from '../../components/CallbackResend/CallbackResend';
import { TokenForm } from './TokenForm/TokenForm';

const BusinessWorkspace = () => {

    const idInit = useParams<string>().slug || '';

    useEffect(() => {
        setCurrentID(idInit)
    }, [idInit])

    const [currentID, setCurrentID] = useState<string | null>(idInit)


    const [entity, setEntity] = useState<EntityType | DataEntityType>()


    const [, doFetchLoad] = useFetch(
        `${API_BUSINESS}business/${idInit}`)//{ error: errLoad, isLoading: isLoadLoad, response: respLoad }



    useEffect(() => {
        if (currentID === "") {
            return
        }
        doFetchLoad({
            method: 'GET',
            "Content-Type": "application/json"
        }).then(responce => {
            setEntity(responce.data)
        })
    }, [currentID])


    const [rate, setRate] = useState<RateEntityType | null>(null)





    const [, doFetchLoadRate] = useFetch(
        `${API_BUSINESS}rate/business/${currentID}`)//{ error: errLoad, isLoading: isLoadLoad, response: respLoad }

    const [, doFetchSetRate] = useFetch(
        `${API_BUSINESS}rate/business/connect`)//{ error: errLoad, isLoading: isLoadLoad, response: respLoad }


    useEffect(() => {
        if (currentID === "") {
            return
        }
        doFetchLoadRate({
            method: 'GET',
            "Content-Type": "application/json"
        }).then(responce => {
            setRate(responce.data)
        })
    }, [currentID])



    const setRateForBusiness = (idRate: string) => {
        doFetchSetRate({
            method: 'POST',
            "Content-Type": "application/json",
            data: {
                idrfBusiness: currentID,
                idrfRate: idRate
            }
        }).then(responce => {
            console.log(responce)
            setRate(responce.data)

        })

    }






    return (
        <>

            {entity && <><h2>{entity.name}</h2>
                <CopyToClipboard text={entity.idUnique as string}>
                    <span>
                        <i className={"fe fe-clipboard eventIcom"}></i>
                    </span>
                </CopyToClipboard>
            </>}


            {currentID && currentID !== "" &&
                <DashboardBusiessMain idBusinessProps={currentID}></DashboardBusiessMain>
            }


            <BusinessForm
                title={''}
                idInit={currentID}
                handleClose={() => { }}
                initEntityProps={undefined}
            />


            {/* {entity && 
<>
{entity.typeBusiness}
    <Report idBusiness={idInit} idProvider={null}>

    </Report>
    </>
} */}

            {entity && entity.typeBusiness === TypeBusinessEnum.merchant &&
                <Report idBusiness={idInit} idProvider={null}>

                </Report>
            }

            {entity && entity.typeBusiness === TypeBusinessEnum.provider &&
                <Report idBusiness={null} idProvider={idInit}>

                </Report>
            }


            {entity && entity.typeBusiness === TypeBusinessEnum.provider && entity.currencyBalance === entity.currencyPayment &&
                <CalculateDiffExchangeRate idProvider={idInit}>

                </CalculateDiffExchangeRate>
            }

            {entity && entity.typeBusiness === TypeBusinessEnum.merchant && entity.currencyBalance === entity.currencyPayment &&
                <SettleFiatMerchant idMerchant={idInit}>

                </SettleFiatMerchant>
            }

            {entity && entity.typeBusiness === TypeBusinessEnum.merchant && currentID &&
                <CallbackResend businessId={currentID} />
            }






            <Card className="productdesc">
                <Card.Body>
                    <div className="panel panel-primary">
                        <div className="panel-body tabs-menu-body description">
                            <div className="tab-content">

                                <Tabs defaultActiveKey="Specifications" id="uncontrolled-tab-example" className="mb-3">
                                    <Tab className='tab-pane pt-5' eventKey="rate" title="Тариф" >

                                        {/* <NomenclatureSpecificationCharacteristictypeList listFilterFieldProps={listFilterFieldForChar}></NomenclatureSpecificationCharacteristictypeList> */}
                                        <h3>Комиссии тарифа</h3>


                                        {currentID && rate &&
                                            <DRRateComissionList listFilterFieldProps={[{ fieldName: "idrfRate", comparison: "equalsStrong", listVal: [rate?.idUnique ? String(rate?.idUnique) : ""] }]}></DRRateComissionList>
                                        }


                                    </Tab>

                                    {entity && entity.typeBusiness === TypeBusinessEnum.merchant &&
                                        <Tab className='tab-pane pt-5' eventKey="providers" title="Провайдеры">

                                            {currentID &&
                                                <ProductProviderList listFilterFieldProps={[{ fieldName: "idrfBusinessAsProduct", comparison: "equalsStrong", listVal: [currentID] }]}></ProductProviderList>
                                            }
                                        </Tab>
                                    }

                                    {entity && entity.typeBusiness === TypeBusinessEnum.provider &&
                                        <Tab className='tab-pane pt-5' eventKey="providers" title="Мерчанты">

                                            {currentID &&
                                                <ProductProviderList listFilterFieldProps={[{ fieldName: "idrfBusinessAsProvider", comparison: "equalsStrong", listVal: [currentID] }]}></ProductProviderList>
                                            }
                                        </Tab>
                                    }


                                    <Tab className='tab-pane pt-5' eventKey="users" title="Пользователи">

                                        {currentID &&
                                            <UserBusinessList listFilterFieldProps={[{ fieldName: "idEntityDomain", comparison: "equalsStrong", listVal: [currentID] }]}></UserBusinessList>
                                        }
                                    </Tab>


                                    <Tab className='tab-pane pt-5' eventKey="apikeys" title="Ключи доступа">

                                        {currentID &&
                                            <>
                                            <TokenForm idBusiness={currentID}></TokenForm>
                                            </>
                                        }
                                    </Tab>

                                    {entity && entity.typeBusiness === TypeBusinessEnum.provider &&
                                        <Tab className='tab-pane pt-5' eventKey="providercode" title="Код провайдера">

                                            <div className="provider-code-wrapper">
                                                <h4>Генератор кода провайдера</h4>
                                                {entity && (
                                                    <ProviderCodeGenerator
                                                        providerId={entity.idUnique?.toString() || ''}
                                                        serviceUrl={entity.providerURLHost || ''}
                                                        providerName={entity.name?.toLowerCase().replace(/\s+/g, '_') || 'provider_name'}
                                                    />
                                                )}
                                            </div>

                                        </Tab>
                                    }


                                </Tabs>

                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Card>




        </>
    )

}

export default BusinessWorkspace